import type { Theme } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { lightThemeOptions } from "@entrilia/shared/theme";
import { isValidHexColor } from "@entrilia/shared/utilities/colorHelper";

const portalLightTheme = createTheme(lightThemeOptions);

const usePreviewTheme = (accentColor: string): Theme =>
  useMemo(() => {
    if (!isValidHexColor(accentColor)) {
      return portalLightTheme;
    }

    return createTheme(portalLightTheme, { palette: { primary: { main: accentColor } } });
  }, [accentColor]);

export default usePreviewTheme;
